import { _ } from "../../../polyglot/polyglot.js";
import { makeMonitorRepository } from "../../../repositories/repositoryBuilders.js";
import AbstractImporter from "../AbstractImporter.js";
import FiscalYearStep from "./FiscalYearStep.js";
import session from "../../../session.js";
import TokenStep from "../TokenStep.js";
import XledgerIntegration from "../../../../models/integration/XledgerIntegration.js";

/**
 * `XledgerImporter` imports from Xledger integration API.
 */
export default class XledgerImporter extends AbstractImporter {
	constructor() {
		super(...arguments);

		this._xledgerImportRepository = makeMonitorRepository({
			route: "/Shared/Import/xledger",
			antiForgeryToken: session.getAntiForgeryToken(),
		});
	}

	_wizardSteps() {
		return [
			this._createApiTokenStep(),
			this._createFiscalYearSelectionStep(),
		];
	}

	// Step 1: let the user insert the api token
	_createApiTokenStep() {
		return new TokenStep({
			label: _("Api token"),
			hasToken: () => {},
			attribute: "apiToken",
			submitCallback: ({ onDone }) => onDone(),
		});
	}

	// Step 2: let the user select a fiscal year to import.
	_createFiscalYearSelectionStep() {
		return new FiscalYearStep({
			submitCallback: this._fiscalYearToImportData.bind(this),
		});
	}

	// Step 2 ⇒ Step 3: get all the data
	_fiscalYearToImportData({ onDone, step }) {
		this._xledgerImportRepository
			.save({
				filter: {
					fiscalYear: this._context.fiscalYearNumber,
					apiToken: this._context.apiToken,
					companyId: this._companyId,
				},
				notify: false,
			})
			.then((data) => {
				this._context.importData = data;
				onDone();
			})
			.catch((error) => {
				step.addSubmitError(this._errorToMessage(error));
				onDone();
			});
	}

	_errorToMessage(error) {
		switch (error.responseJSON.typeOfError) {
			case "InvalidApiToken": {
				return _("The provided API token is invalid");
			}
			case "InsufficientFund": {
				return _(
					"Insufficient credits. Your credits will reset at {resetTime}.",
					{ resetTime: error.responseJSON.message },
				);
			}
			default: {
				return error.responseJSON.message;
			}
		}
	}
}

XledgerImporter.integrationType = XledgerIntegration.getType();
